// BREACH TYPE OF EVIDENCE
export const GET_BREACH_TYPES_OF_EVIDENCE = '/breach-type-of-evidence/query';
export const GET_BREACH_TYPE_OF_EVIDENCE = '/breach-type-of-evidence/';
export const POST_BREACH_TYPE_OF_EVIDENCE = '/breach-type-of-evidence/';
export const PUT_BREACH_TYPE_OF_EVIDENCE = '/breach-type-of-evidence/';
export const DELETE_BREACH_TYPE_OF_EVIDENCE = '/breach-type-of-evidence/';
export const CHECK_BREACH_TYPE_OF_EVIDENCE_EXISTS = '/breach-type-of-evidence/query';
